import globalAxios from "../GlobalAxios";

const listApi = async (data) => {
  try {
    const res = await globalAxios.post('/api/live/list', data );
    return res.data;
  } catch (error) {
    console.error("error", error);
  }
}

const deleteApi = async (data) => {
  try {
    const res = await globalAxios.delete('/api/live/delete', { data });
    return res.data;
  } catch (error) {
    console.error("error", error);
  }
}

const addApi = async (data) => {
  try {
    const res = await globalAxios.post('/api/live/create', data);
    return res.data;
  } catch (error) {
    console.error("error", error);
  }
}

const saveStreamApi = async (data) => {
  try {
    const res = await globalAxios.post('/api/live/saveStream', data);
    return res.data;
  } catch (error) {
    console.error("error", error);
  }
}

const wowzaCheckApi = async () => {
  try {
    const res = await globalAxios.get('/api/live/wowzadb_healthcheck');
    return res.data;
  } catch (error) {
    console.error("error", error);
  }
}

const detailApi = async (data) => {
  try {
    const res = await globalAxios.post('/api/live/liveitems', data );
    return res.data;
  } catch (error) {
    console.error("error", error);
  }
}

const getApplicationApi = async () => {
  try {
    const res = await globalAxios.post('/api/live/application');
    return res.data;
  } catch (error) {
    console.error("error", error);
  }
}

const getRecordListApi = async (ip) => {
  try {
    const res = await globalAxios.get('/api/live/record-list',  {params: {ip}});
    return res.data;
  } catch (error) {
    console.error("error", error);
  }
}

const recordDeleteApi = async (items) => {
  try {
    const res = await globalAxios.post('/api/live/record-delete', {items});
    return res.data;
  } catch (error) {
    console.error("error", error);
  }
}

const recordMoveToApi = async (items) => {
  try {
    const res = await globalAxios.post('/api/live/record-toAsset', {items});
    return res.data;
  } catch (error) {
    console.error("error", error);
  }
}

const recordDownloadApi = async (data) => {
  try {
    const res = await globalAxios.get('/api/live/record-download', data);
    return res.data;
  } catch (error) {
    console.error("error", error);
  }
}

const updateStreamOnOffApi = async (data) => {
  try {
    const res = await globalAxios.post('/api/live/pullstreamonoff', data);
    return res.data;
  } catch (error) {
    console.error("error", error);
  }
}

const updateRecordingOnOffApi = async (data) => {
  try {
    const res = await globalAxios.post('/api/live/pullrecordingonoff', data);
    return res.data;
  } catch (error) {
    console.error("error", error);
  }
}

const checkStatus = async (data) => {
  try {
    const res = await globalAxios.post('/api/live/pullrecordstatus', data);
    return res.data;
  } catch (error) {
    console.error("error", error);
  }
}

const pullRecordingSwitchOn = async (data) => {
  try {
    const res = await globalAxios.post('/api/live/pullrecordingswitchon', data);
    return res.data;
  } catch (error) {
    console.error("error", error);
  }
}

const pullRecordingSwitchOff = async (data) => {
  try {
    const res = await globalAxios.post('/api/live/pullrecordingswitchoff', data);
    return res.data;
  } catch (error) {
    console.error("error", error);
  }
}


const pullLoadBalancerApi = async (data) => {
  try {
    const res = await globalAxios.post('/api/live/statusCheck', data);
    return res.data;
  } catch (error) {
    console.error("error", error);
  }
}


export default {
  listApi,
  deleteApi,
  addApi,
  saveStreamApi,
  wowzaCheckApi,
  detailApi,
  getApplicationApi,
  getRecordListApi,
  recordDeleteApi,
  recordMoveToApi,
  recordDownloadApi,
  updateRecordingOnOffApi,
  checkStatus,
  pullRecordingSwitchOn,
  pullRecordingSwitchOff,
  updateStreamOnOffApi,
  pullLoadBalancerApi
};